<template>
  <div class="home">
    <div class="bannder" v-if="pcis">
      <div class="bannder-area">
        <div class="bannder-text">
          <p class="bannder-title" ref="title">蓝小助SCRM系统</p>
          <div class="content" ref="bannderContent">
            <p class="bannder-content">线上大批量普工招聘解决方案</p>
            <p class="bannder-content">企业搭建自己的线上普工招聘平台</p>
            <el-button type="primary" class="bannder-btn" @click="informationFn">马上申请体验</el-button>
          </div>
        </div>
        <div class="bannder-img" ref="bannderImg">
          <img src="@/assets/首页插画.svg" alt="banner">
        </div>
      </div>
    </div>
    <div class="banner-move" v-else>
      <div class="information-bg" ref="infor_bg"></div>
      <div class="information-move" ref="infor">
        <img src="@/assets/qrCode.jpg" alt class="qccode-img" />
        <p class="information-text">长按识别二维码关注公众号</p>
        <p class="information-text-two">与在线客服直接沟通</p>
        <p class="phone"><span class="iconfont icon-dianhua"></span>客服热线</p>
        <p class="phone-num">0755-8320 7865</p>
        <div class="sizes" @click="onClick">
          <img src="@/assets/x.png" alt />
        </div>
      </div>
      <div class="move-area">
        <p class="move-title">蓝小助SCRM系统</p>
        <p class="move-text">线上大批量普工招聘解决方案</p>
        <p class="move-text">企业搭建自己的线上普工招聘平台</p>
        <el-button type="primary" class="move-bannder-btn" @click="informationMoveFn">马上申请体验</el-button>
      </div>
      <div class="move-bannder-img">
      </div>
    </div>
    <!-- <main class="main" :style="{'width':moduleInfoDisplayWidth,'margin':'auto'}">
      <el-row class="module">
        <div class="module-title">
          <span>
            企业私域运营一站式解决方案
            <span></span>
          </span>
        </div>
        <el-row :gutter="32">
          <el-col :xs="24" :sm="12" :md="8" :lg="8">
            <el-card class="plan-box-card">
              <img src="@/assets/plan-one.svg" @mouseover="overPlanImg($event, 'one')" ref="imgone"/>
              <div class="plan-title" @click="planImgShow = !planImgShow">
                搭建线上招聘平台
              </div>
              <div class="plan-content">
                为企业赋能，迅速打造属于自己的私域流量池
              </div>
            </el-card>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="8">
            <el-card class="plan-box-card">
              <img src="@/assets/plan-two.svg" @mouseover="overPlanImg($event, 'two')" ref="imgtwo"/>
              <div class="plan-title">
                智能营销转化
              </div>
              <div class="plan-content">
                精细化运营，分析粉丝来源高效转化到1v1定制服务，进行私域流量转化
              </div>
            </el-card>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="8">
            <el-card class="plan-box-card">
              <img src="@/assets/plan-three.svg" @mouseover="overPlanImg($event, 'three')" ref="imgthree"/>
              <div class="plan-title">
                智能粉丝裂变
              </div>
              <div class="plan-content">
                精准快速裂变，流量池粉丝资源最大化
              </div>
            </el-card>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="8">
            <el-card class="plan-box-card">
              <img src="@/assets/plan-four.svg" @mouseover="overPlanImg($event, 'four')" ref="imgfour"/>
              <div class="plan-title">
                智能精准推送
              </div>
              <div class="plan-content">
                多维度互动粉丝，通过智能推送工具在私域流量池最大化激活粉丝
              </div>
            </el-card>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="8">
            <el-card class="plan-box-card">
              <img src="@/assets/plan-five.svg" @mouseover="overPlanImg($event, 'five')" ref="imgfive"/>
              <div class="plan-title">
                智能客服系统
              </div>
              <div class="plan-content">
                智能分配客户，打造专属1v1客服服务
              </div>
            </el-card>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="8">
            <el-card class="plan-box-card">
              <img src="@/assets/plan-six.svg" @mouseover="overPlanImg($event, 'six')" ref="imgsix"/>
              <div class="plan-title">
                企业团队管理
              </div>
              <div class="plan-content">
                为企业量身定制一套员工管理系统
              </div>
            </el-card>
          </el-col>
        </el-row>
      </el-row>
      <el-row class="module">
        <div class="module-title">
          <span>
            完整解决方案
            <span></span>
          </span>
        </div>
        <el-row class="complete-plan">
          <el-col :xs="24" :sm="24" :md="12" :lg="12" class="complete-plan-text">
            <div class="complete-plan-text-item">
              <p class="complete-plan-title">
                企业为什么需要搭建私域流量池？
              </p>
              <p class="complete-plan-content">
                互联网流量红利已过，网络平台大多采用竞价机制，获取流量的成本越来越贵，这是
  劳务派遣工司网络招聘必须考虑清楚的转型话题，头部劳务派遣公司在这砸广告获取
  流量方面有天然的优势，但这个做法可能并不适合大部分劳务派遣公司，通俗讲就是，
  那个网络平台流量就一定量级，大家都想要，必定恶性竞争，成本变得越来越高，中
  小劳务派遣公司胜出几率偏低。
              </p>
              <div class="complete-plan-content-list">
                <div><span class="point"></span> 构建可复用普工人力业务私域流量池；</div>
                <div><span class="point"></span> 利用大数据平台，全方位锁定高质量用户，打造更精准的服务；</div>
                <div><span class="point"></span> 为企业实现长期低成本线上、线下获取高质量客户；</div>
                <div><span class="point"></span> 颠覆传统沟通方式，实现智能、快速、灵活的高效沟通流程。</div>
              </div>
            </div>
          </el-col>
          <AnimationOne ref="AnimationOneRef"></AnimationOne>
        </el-row>
        <el-row class="complete-plan backgroundColor" style="padding-bottom: 0">
          <AnimationTwo ref="AnimationTwoRef"></AnimationTwo>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" class="complete-plan-text complete-plan-text-right">
            <div class="complete-plan-text-item">
              <p class="complete-plan-title">
                蓝小助能给客户带来什么？
              </p>
              <p class="complete-plan-content">
                蓝小助基于微信公众号为人力资源行业专门定制的一套线上招聘平台，同时结合微信
公众号自身的优势为人力资源行业打造一站式服务。
              </p>
              <div class="complete-plan-content-list">
                <div> 私域流量池 <span class="point"></span></div>
                <div> 粉丝裂变 <span class="point"></span></div>
                <div> 精准化运营 <span class="point"></span></div>
                <div> 智能推送 <span class="point"></span></div>
                <div> 高转化率 <span class="point"></span></div>
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row class="complete-plan">
          <el-col :xs="24" :sm="24" :md="12" :lg="12" class="complete-plan-text">
            <div class="complete-plan-text-item">
              <p class="complete-plan-title">
                粉丝裂变的价值
              </p>
              <p class="complete-plan-content">
                蓝小助是一款基于微信生态圈专门为人力资源行业打造的一款专业的营销工具，在粉
丝裂变方案中主要具备以下特点：裂变效率高、路径体验好、无流量损耗、适用性强、
用户精准度高、流量大、可长期运营作为用户服务平台。
              </p>
              <div class="complete-plan-content-list">
                <div><span class="point"></span> 精准获客</div>
                <div><span class="point"></span> 介绍客服系统</div>
                <div><span class="point"></span> 聚合多平台公域流量，实现统一高效化</div>
              </div>
            </div>
          </el-col>
          <AnimationThree ref="AnimationThreeRef"></AnimationThree>
        </el-row><el-row class="complete-plan backgroundColor" style="padding-bottom: 0">
          <AnimationFour ref="AnimationFourRef"></AnimationFour>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" class="complete-plan-text complete-plan-text-right">
            <div class="complete-plan-text-item">
              <p class="complete-plan-title">
                蓝小助是如何精准获客？
              </p>
              <p class="complete-plan-content">
                蓝小助是一款基于微信生态圈专门为人力资源行业打造的一款专业的营销工具，在用
户信息保存上针对用户来源、标签、用户基本信息等多维度进行粉丝筛选，同时通过
智能化工具为 人力资源企业迅速上手全力为企业打造轻松上手的智能化平台，蓝小助
为企业提供一站式解决方案。
              </p>
              <div class="complete-plan-content-list">
                <div> 多维度粉丝筛选 <span class="point"></span></div>
                <div> 打造智能化平台 <span class="point"></span></div>
                <div> 提供解决方案 <span class="point"></span></div>
                <div> 专业营销工具 <span class="point"></span></div>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-row>
    </main> -->
  </div>
</template>

<script>
// import { mapState, mapGetters, mapActions } from 'vuex'; //先要引入
export default {
  components: {
    // AnimationOne: () => import('./components/animation-one'),
    // AnimationTwo: () => import('./components/animation-two'),
    // AnimationThree: () => import('./components/animation-three'),
    // AnimationFour: () => import('./components/animation-four')
  },
  data () {
    return {
      visible: true,
      height: '860px',
      moduleInfoDisplayWidth: '1200px',
      planImgShow: false,
      scrollTop: null, // 滚动条
      pcis: this.$store.state.pcIs, // 根据窗口大小变化来判断移动端PC端
    }
  },
  // computed: {
  //   ...mapState({
  //     isShow: state => state.visible
  //   })
  // },
  mounted () {
    // if (this.isShow) {
    //   setTimeout(() => {
    //     this.$refs.infor.style.transition = "right 3s linear"
    //     this.$refs.infor.style.right = "15px"
    //   }, 0)
    // }
    let that = this;
    const winWidth = window.innerWidth;
    that.widthFn(winWidth)
    window.onresize = function windowResize() {
      // 通过捕获系统的onresize事件触发我们需要执行的事件
      that.widthFn(window.innerWidth)
    }
    window.addEventListener('scroll', this.animationStartFn);
    setTimeout(() => {
      this.animationStartFn()
    }, 1000)
    this.initialAnimation()
  },
  watch: {
    // isShow (newVal) {
    //   if (newVal) {
    //     setTimeout(() => {
    //       this.$refs.infor.style.transition = "right 3s linear"
    //       this.$refs.infor.style.right = "15px"
    //     }, 0)
    //   }
    // }
  },
  destroyed(){
    window.removeEventListener('scroll', this.getScroll);
  },
  methods: {
    initialAnimation () {
      if (!this.pcis) return
      setTimeout(() => {
        console.log(this.$refs);
        this.$refs.title.style.transition = "all 1.5s ease-out"
        this.$refs.title.style.top = "0"
        this.$refs.title.style.opacity = 1
        this.$refs.bannderContent.style.transition = "all 1.5s ease-out"
        this.$refs.bannderContent.style.bottom = "0"
        this.$refs.bannderContent.style.opacity = 1
        this.$refs.bannderImg.style.transition = "all 1.5s ease-out"
        this.$refs.bannderImg.style.right = "0"
        this.$refs.bannderImg.style.opacity = 1
      })
    },
    informationFn () {
      this.$store.commit('setvisible', false)
      this.$nextTick(() => {
        this.$store.commit('setvisible', true)
      })
    },
    informationMoveFn () {
      this.$refs.infor.style.bottom = "0px"
      this.$refs.infor.style.transition = "bottom 2s linear"
      setTimeout(() => {
        this.$refs.infor_bg.style.display = "block"
      }, 1000)
    },
    animationStartFn () {
      this.$nextTick(() => {
        const scrollTop = document.documentElement.scrollTop
        if (!!scrollTop && scrollTop >= 1100 && scrollTop < 2279){            
          // 滚动到指定位置开始动画
          this.$refs.AnimationOneRef && this.$refs.AnimationOneRef.animationStart()
        } 
        if (!!scrollTop && scrollTop >= 2100 && scrollTop < 3100) {
          this.$refs.AnimationThreeRef && this.$refs.AnimationThreeRef.animationStart()
        }
      })
    },
    onClick () {
      this.$refs.infor.style.transition = "right 1s linear"
      this.$refs.infor.style.bottom = "-100%"
      this.$refs.infor_bg.style.display = "none"
      setTimeout(() => {
        this.$store.commit('setvisible', false)
      }, 1000)
    },
    widthFn (w) {
      var h = 860
      if (w > 1920) {
        h = 860
      } else {
        h = 0.45 * w
      }
      if (w > 1200) {
        this.moduleInfoDisplayWidth = 1170 + 'px'
      } else {
        this.moduleInfoDisplayWidth = (w - 30) + 'px'
      }
      this.height = h + 'px'
    },
    overPlanImg (e, index) {
      const target = this.$refs[ 'img' + index]
      target.style.transform = 'scale(1.2)'
      target.style.transition = 'all .3s ease'
      setTimeout(() => {
        target.style.transform = 'scale(1)'
        target.style.transition = 'all .3s ease'
      }, 300)
    }
  }
};
</script>
<style lang='less' scoped>
p {
  margin: 0;
}
.home {
  width: 100%;
  z-index: 2;
  position: relative;
  letter-spacing: 1px;
  .bannder {
    width: 100%;
    height: 900px;
    background: url('~@/assets/banner-bg.png') no-repeat;
    background-size: 100% 100%;
    .bannder-area {
      width: 1200px;
      height: 100%;
      padding: 0 15px;
      margin: auto;
      display: flex;
      .bannder-text {
        width: 457px;
        height: 100%;
        margin-right: 65px;
        .bannder-title {
          position: relative;
          top: -200px;
          font-size: 54px;
          font-weight: 800;
          color: #FFFFFF;
          line-height: 70px;
          margin-top: 224px;
          margin-bottom: 36px;
          opacity: 0;
        }
        .content {
          position: relative;
          bottom: -400px;
          opacity: 0;
        }
        .bannder-content {
          color: #fff;
          font-size: 27px;
          line-height: 45px;
        }
        .bannder-btn {
          width: 231px;
          height: 61px;
          background: #FFA802;
          margin-top: 67px;
          border-radius: 36px;
          border: 1px solid #979797;
          font-size: 28px;
          font-weight: bold;
          color: #FFFFFF;
        }
      }
      .bannder-img {
        position: relative;
        opacity: 0;
        right: -646px;
        height: 100%;
        >img {
          position: absolute;
          top: 171px;
          left: 0;
          width: 646px
        }
      }
    }
  }
  .module {
    .module-title{
      text-align: center;
      font-size: 30px;
      font-weight: bold;
      color: #454545;
      line-height: 57px;
      margin-top: 80px;
      margin-bottom: 60px;
      >span {
        position: relative;
        display: inline-block;
        padding-bottom: 10px;
        border-bottom: 2px solid #d5d5d5;
        >span {
          position: absolute;
          left: 20%;
          bottom: -4px;
          display: inline-block;
          width: 60%;
          border: 3px solid #2C62FA
        }
      }
    };
    .plan-box-card {
      width: 100%;
      height: 253px;
      background: #FFFFFF;
      box-shadow: 0px 2px 22px 0px rgba(13, 44, 132, 0.35);
      border-radius: 16px;
      margin-top: 33px;
      padding: 24px 40px 20px;
      .plan-title {
        font-size: 20px;
        font-family: SourceHanSansCN-Bold, SourceHanSansCN;
        font-weight: bold;
        color: #333333;
        line-height: 28px;
        margin-top: 30px;
      }
      .plan-content {
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        line-height: 23px;
        margin-top: 5px;
      }
      img {
        width: 80px;
        height: 65px;
      }
    }
    .complete-plan {
      margin: 20px 0;
      padding: 20px 0 50px 0;
      .complete-plan-text {
        padding: 40px 0 0 0 ;
        display: flex;
        justify-content: center;
        .complete-plan-text-item{
          max-width: 585px;
        }
      }
      .complete-plan-text-right {
        text-align: right;
      }
      .complete-plan-title {
        font-size: 28px;
        font-family: SourceHanSansCN-Bold, SourceHanSansCN;
        font-weight: bold;
        color: #333333;
        line-height: 38px;
        margin-bottom: 20px;
      }
      .complete-plan-content {
        font-size: 15px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #666666;
        line-height: 24px;
      }
      .complete-plan-content-list {
        font-size: 16px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #666666;
        line-height: 16px;
        margin-top:20px;
        >div {
          margin: 5px 0;
        }
      }
    }
  }
  .backgroundColor {
    background: linear-gradient(270deg, rgba(255, 255, 255, 0) 0%, #cadffd 52%, rgba(255, 255, 255, 0) 100%);
  }
  .point {
    display:  inline-block;
    width: 6px;
    height: 6px;
    line-height: 6px;
    background: #2C62FA;
    border-radius: 50%;
    vertical-align: middle;
  }
}
.plan-img-show-enter-active {
  animation: plan-img-show-in .5s;
}
.plan-img-show-leave-active {
  animation: plan-img-show-in .5s reverse;
}
@keyframes plan-img-show-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.5);
  }
  100% {
    transform: scale(1);
  }
}
</style>
<style lang="less" scoped>
.information-bg {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, .5);
  display: none;
}
.information-move {
  width: 100%;
  height: 1039px;
  background: url('~@/assets/modal-bg.png');
  background-size: 100% 100%;
  position: fixed;
  z-index: 777;
  bottom: -100%;
  border-radius: 15px 15px 0 0;
  text-align: center;
  padding: 86px 0 0;
  .qccode-img {
    width: 501px;
    height: 501px;
  }
  .information-text {
    font-size: 51px;
    font-weight: normal;
    color: #04A8FF;
    line-height: 70px;
  }
  .information-text-two {
    font-size: 67px;
    font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
    font-weight: 500;
    color: #04A8FF;
    line-height: 93px;
  }
  .phone {
    font-size: 48px;
    margin-top: 78px;
    font-weight: normal;
    color: #333333;
    line-height: 67px;
    .iconfont {
      font-size: 50px;
      margin-right: 16px;
    }
  }
  .phone-num {
    font-size: 77px;
    font-weight: 700;
    color: #333333;
    line-height: 104px;
  }
  .sizes {
    position: absolute;
    top: 5px;
    right: 0;
    width: 80px;
    height: 80px;
    transform: translateX(-50%);
    font-size: 80px;
    cursor: pointer;
    img {
      width: 100%;
    }
  }
}
// 移动端
.banner-move {
  background: linear-gradient(226deg, #002FFC 0%, #3784EF 100%);
  padding-top: 93px;
  padding-bottom: 98px;
  .move-area {
    color: #FFFFFF;
    text-align: center;
    .move-title {
      font-size: 114px;
      font-weight: 800;
      margin-bottom: 67px;
    }
    .move-text {
      font-size: 55px;
      font-family: SourceHanSansCN-Normal, SourceHanSansCN;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 82px;
      margin-bottom: 13px;
    }
    .move-bannder-btn {
      width: 428px;
      height: 107px;
      background: #FFA802;
      border-radius: 73px;
      margin-top: 90px;
      border: 1px solid #979797;
      color: #FFFFFF;
      font-size: 49px;
    }
  }
  .move-bannder-img {
    margin: 122px auto 0;
    // margin: 750px auto 0;
    width: 1058px;
    height: 779px;
    background: url('~@/assets/首页插画.svg');
    background-size: 100% 100%;
  }
}
</style>
